import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import params from "../../global_parameters";

export const TCText = [
  {
    id: "T&Cs",
    text: (
      <Fragment>
        <h1>Terms and Conditions</h1>
        <p>
          By using the illustrator, you agree you have read, understood, and agreed to the Terms & Conditions set out below.
        </p>
        <h3>1. Use of this illustrator</h3>
        <p>
        The illustrator is solely for guidance purposes and provides an illustration only. It is not intended to provide financial advice. If you require financial advice, you should contact an independent financial adviser. The Government Actuary’s Department (GAD) and the NHS Pension Scheme and its administrators do not accept any liability for financial decisions taken based on the information provided in the illustrator. 
        </p>
        <p>
        The illustrator does not calculate any statutory or contractual redundancy payment and does not confirm whether you qualify for any redundancy related pension terms. Any indication that you could take pension benefits in connection with redundancy is subject to eligibility and employer confirmation. 
        </p>
        <p>
          Members may be able to claim back the cost of advice by applying 
          for the <a href="https://www.nhsbsa.nhs.uk/public-service-pensions-remedy-mccloud/nhs-cost-claim-back-scheme" target = "_blank">Cost Claim Back Scheme</a>.
        </p>
        <p>
          The results shown are an indication of the benefits you may receive;
          they are not guaranteed and you should not enter into financial
          commitments on the basis of the information provided.
        </p>
        <p>
          The illustrator does not override the scheme rules or pension
          legislation.
        </p>
        
        <h3>2. How your pension and lump sum have been calculated</h3>
        <h3>
          2.1. Choice of benefits accrued over 1 April {params.remedy_start} to
          31 March 2022
        </h3>
        <p>
        The results section shows a comparison of pension and lump sum benefits that 
        might be received if you choose either Option A (Standard Benefits) or Option B
        (Alternative Benefits) for the remedy period, which is from 1 April 2015 to 
        31 March 2022. Member contributions are not included in the figures.
        </p>
        <h3>2.2. Assumptions</h3>
        <p>
          The pension and lump sum illustrations are based on the following
          key assumptions:
        </p>
        <ul>
          <li>Actual Consumer Price Inflation (CPI) is applied up to today’s date </li>
          <li>Consumer Price Inflation (CPI) is assumed to be 2% a year for future projections </li>
          <li>
            Your total 2015 Scheme pension is revalued in line with prices (CPI) + 1.5% 
            every year that you are an active member of the 2015 Scheme. 
          </li>
          <li>Salaries are assumed to increase at a rate of 2% per year</li>
          <li> A flat service cap of 45 years in the 1995 Section is assumed at all ages for all members, other than Mental Health Officers, where a flat cap of 40 years is assumed (before any adjustment for double accrual).</li>
        </ul>
        <h3>2.3. Adjustments for early or late payment of pension</h3>
        <p>The amount of pension you receive depends on when you retire.</p>
        <p>
          Claiming your pension earlier than your Normal Pension Age (NPA) means it will be 
          permanently reduced because it will be paid to you for longer.
        </p>
        <p>
          Each part of the NHS Pension Scheme has a different NPA. This illustrator applies 
          adjustments when pension and lump sum are taken earlier or later than the relevant part of the 
          scheme’s (NPA), in line with the Scheme rules. Allowance for late retirement factors 
          has been made for members retiring after their NPA in the 2008 Section and 2015 Scheme. 
          There are no late retirement factors applicable to the 1995 Section. 
        </p>
        <p>
          The early and late retirement adjustment factors used in this illustrator are based on the factors 
          currently used by the NHS Pension Scheme. These will be reviewed from time to time and may increase 
          or decrease. Your benefits at retirement will depend on any adjustment factors at the time.
        </p>
        <h3>2.4. Cash lump sum</h3>
        <p>
          At retirement, you will get an automatic lump sum from service in the 1995 Section of the 1995/2008 Scheme. This is 
          usually three times your pension (prior to any adjustment, if applicable). You are eligible to 
          permanently reduce your pension in exchange for a one-off lump sum from all of the NHS pension 
          schemes – this is called commutation. You can change the assumed lump sum on the 
          'Show Detail' page.
        </p>
        <h3>3. Taxation</h3>
        <p>
          The illustrations do not allow for taxation. Your benefits will be
          subject to the 
          <a href = "https://www.gov.uk/guidance/calculate-your-public-service-pension-adjustment " target = '_blank'> various tax rates and limits in force. </a>
        </p>
        <h3> 4. Other</h3>


<p> 
Your Scheme provides survivor benefits payable in the event of your death, which are not shown here. See your Scheme guide for details. Your benefit statement may also include more about this.
</p>

<p> 
For Mental Health Officers, the illustrator makes allowance for double accrual and Uniform Accrual Formulae in a necessarily approximate way and may not fully reflect all circumstances.
</p>

<p> 
It has been assumed the normal retirement age for Mental Health Officers is age 55. 
</p>

      </Fragment>
    ),
  },
];

export const SmallPrintText = [
  {
    id: "SP",
    text: (
      <Fragment>
        <h2>How to use this calculator</h2>
        <p>
        It will not check your information against pension or other systems,
        so if you enter inaccurate information, the figures you get will be 
        of limited value. No data you enter into this calculator is stored 
        or processed.
        </p>
        <p>
          By using this calculator, you agree that you have read
          and understood the Terms & Conditions as set out in the{" "}
          <Link to="/T&Cs">T&Cs' tab</Link>.
        </p>
        <p>
          This calculator is for guidance and illustration - 
          it will give you a basic illustration of your pension benefits 
          in the 2015 Scheme and your legacy scheme in two scenarios: 
          Option A (Standard Benefits) and Option B (Alternative Benefits). 
          Things such as tax debits are not taken into account. If you have these, 
          or other additional options, the figures you get may be less accurate, 
          but still helpful. The outputs of the calculator are not financial 
          advice - if you’d like to speak to an independent financial adviser 
          you can find one at <a href="https://www.unbiased.co.uk/" target = "_blank">unbiased.co.uk</a>.
        </p>
        <p style = {{'fontWeight' : 'bold'}}>The assumptions we have used are:</p>
        <table>
          <tbody>
            <tr>
              <td>Consumer Price Index</td>
              <td>Real values for past inflation; an annual rate of 2% for future inflation</td>
            </tr>
            <tr>
              <td>Earnings inflation</td>
              <td>Equal to Consumer Price Inflation, i.e., real salary growth of 0%</td>
            </tr>
          </tbody>
        </table>
        <p>
        The figures output by the calculator are projected benefits and will not
         be the same as those in your Annual Benefit Statement.
        </p>
        <p>
        The projected benefits in this calculator are in “today's money” – 
        this means the values are adjusted for inflation and represent what 
        the pension would be worth today, so you can compare it with your 
        current earnings and the amount you think you’ll need in retirement.
        </p>
      </Fragment>
    ),
  },
];

export const IntroText = [
  {
    id: "IT",
    text: (
      <Fragment>
        <h2>Welcome to the NHS Pensions Remedy Benefits Illustrator</h2>
        <p>
          On 1 April 2015, the government made changes to public service pension 
          schemes which treated members differently based on their age. To put 
          right this age discrimination, affected members will be asked to choose 
          the benefits that are best for them. 
        </p>
        <p>
          This is known as the Public Service Pension Schemes Remedy (PSP Remedy), 
          sometimes called the McCloud remedy. 
        </p>
        <p>
          The PSP Remedy means that affected members have a choice between receiving 
          1995/2008 Scheme or 2015 Scheme benefits for their membership during 
          the remedy period, which is between <b>1 April 2015 and 31 March 2022</b>. 
        </p>
        <h2>This illustrator is designed to help you understand your remedy choice</h2>
        <p> This illustrator can give you an idea of how your total pension benefits are affected by your remedy choice. It’s not an exact projection or a final retirement benefit offer, and can’t be used as financial advice.  </p>
        <p> From later in 2025, when you apply to retire you will receive a letter with accurate figures to help you make your choice.  </p>
        <p>
        Total Reward Statements (TRS) will also change to show you how the value of your pension benefits is affected by the PSP Remedy. You’ll be able to see the current value of your pension benefits if you choose 1995/2008 Scheme benefits for the remedy period, and an alternative view with 2015 Scheme benefits applied for the remedy period.  
        </p>
        
        <br></br>
        <h2>About your choice</h2>
        
        <p>You have two options to choose from:</p>
        
        <h3> Option A: Standard benefits</h3>
        <ul>
        <li>
        1995/2008 Scheme benefits for your membership up to 1 April 2015,  
        </li>
        
          
          <li> plus <b> 1995/2008 Scheme benefits for the remedy period, </b> </li>
          
          <li> plus 2015 Scheme benefits from 1 April 2022. </li>
        </ul>

         <h3> Option B: Alternative benefits.  </h3>

        <ul>
         <li>  1995/2008 Scheme benefits for your membership up to 1 April 2015, </li>

         <li>  plus <b> 2015 Scheme benefits for the remedy period,  </b> </li>
          
         <li> plus 2015 Scheme benefits from 1 April 2022. </li> 
        </ul> 

        <p>
          Both schemes offer highly valuable benefits, but there are some differences. 
          Using this tool can help you to understand how different factors, like your 
          retirement age or the amount of lump sum you want to take, may affect your 
          overall pension benefits.
        </p>

       
        <h2> You’ll get accurate figures to help you make your choice on retirement. </h2>
        <p>
        Later in 2025, active members who are affected by the PSP Remedy will be able to make their remedy choice at the point they apply to retire. You’ll receive a letter showing your options using personalised and accurate figures, with instructions for how to confirm your choice. 
        </p>
        <p>
          For the majority of affected members, their remedy choice will be straightforward. 
        </p>
        <p> 
          A small number of members with complex circumstances may find they need independent 
          financial advice to help them make their choice. These members may be able to claim 
          back the cost of this advice by applying for 
          the <a href="https://www.nhsbsa.nhs.uk/public-service-pensions-remedy-mccloud/nhs-cost-claim-back-scheme" target="_blank">
          Cost Claim Back Scheme</a>. 
        </p>
      </Fragment>
    ),
  },
];

export const ASText = [
  {
    id: "AS",
    text: (
      <Fragment>
        <h1>Accessibility Statement for the NHS (England & Wales) Partial Retirement Calculator</h1>
          <p>This accessibility statement applies to the NHS Business Services Authority website content published on the www.nhsbsa.nhs.uk domain. 
          It does not apply to nhsbsa.nhs.uk subdomains (for example, <a href="https://services.nhsbsa.nhs.uk/check-for-help-paying-nhs-costs/"> https://services.nhsbsa.nhs.uk/check-for-help-paying-nhs-costs </a>).
          </p>

          <p>This website is run by the NHS Business Services Authority (NHSBSA). We want as many people as possible to be able to use this website. 
            For example, that means you should be able to:</p>
            <ul style = {{'fontSize' : '17px'}}>
            <li>change colours, contrast levels and fonts </li>
            <li>zoom in up to 400% without the text spilling off the screen</li>
            <li>navigate most of the website using just a keyboard</li>       
            <li>listen to most of the website using a screen reader</li> 
            </ul>
          <p>We've also made the website text as simple as possible to understand.</p>
          <p><a href="https://mcmw.abilitynet.org.uk/">AbilityNet</a> has advice on making your device easier to use if you have a disability.</p>
        
        <h2>How accessible this website is</h2>
          <p>We know some parts of this website are not fully accessible, as:</p>
            <ul style = {{'fontSize' : '17px'}}>
              <li>you cannot skip to the main content when using a keyboard or screen reader</li>
              <li>when using a keyboard to navigate our cookie banner, there is no focus indicator on the 'Analytics cookies' toggle</li>
              <li>some pages skip a heading level</li>
              <li>some pages use directional language</li>
              <li>not all our form controls have labels to describe their purpose</li>
              <li>some links do not describe where they will take the user or what the linked downloadable content is</li>
              <li>title text is duplicated in some of our content links </li>
              <li>tables do not use headings correctly</li>
              <li>screen readers cannot read some elements correctly, such as filters, embedded videos and social media sharing buttons</li>
              <li>many of our documents require a separate program to open them and are not fully accessible</li>
              <li>you cannot navigate this website using speech recognition software</li>
            </ul>
        
        <h2>Feedback and contact information</h2>
          <p>Contact us if you need information about this website in a different format, such as accessible PDF, large print, easy read, audio recording or braille. 
            We'll consider your request and get back to you within 5 working days.</p>
          <p>We're always looking to improve the accessibility of this website. 
              If you find any problems that are not listed on this page or think we're not meeting accessibility requirements, you can contact us using the same email address:</p>
          <p>Email: <a href="accessibility@nhsbsa.nhs.uk ">accessibility@nhsbsa.nhs.uk</a></p>
          <p>This email address is only for accessibility queries. It is not for technical queries or IT problems. 
            If you have a query that is not about accessibility, you can contact us by: </p>
          <p>Email: <a href="digitalandonline@nhsbsa.nhs.uk" >digitalandonline@nhsbsa.nhs.uk</a></p>
            
        <h2>Enforcement procedure</h2>
          <p>The Equality and Human Rights Commission (EHRC) is responsible for enforcing the Public Sector Bodies (Websites and Mobile Applications) (No. 2) 
            Accessibility Regulations 2018 (the 'accessibility regulations').</p>
          <p>If you're not happy with how we respond to your complaint, <a href="https://www.equalityadvisoryservice.com/">contact the Equality Advisory and Support Service (EASS)</a>.</p>
             
        <h2>Technical information about this website's accessibility</h2>
          <p>The NHS Business Services Authority is committed to making its website accessible, in accordance with the Public Sector Bodies (Websites and Mobile Applications) (No. 2) Accessibility Regulations 2018.</p>
          
        <h3>Compliance status</h3>
          <p>This website is partially compliant with the <a href="https://www.w3.org/TR/WCAG22/">Web Content Accessibility Guidelines version 2.1 AA standard</a>, 
          due to the non-compliances and exemptions listed below.</p>
        
        <h3>Non-accessible content</h3>
          <p>The content listed below is non-accessible for the following reasons.</p>
          
        <h2>Non-compliance with the accessibility regulations</h2>
        <h1>Navigation</h1>
          <p>The 'Skip to main content' link does not bypass the search bar and service navigation to allow users to skip to the main content on a page. 
            This will make navigation hard for keyboard users. This fails WCAG 2.2 success criterion 2.4.1 (Bypass Blocks).</p>
          <p>The tab order on our homepage service list isn't in the correct order. This can be confusing for keyboard users. 
            This fails WCAG 2.2 success criterion 2.4.3.</p>
          <p>When using a keyboard to navigate our cookie banner, there is no focus indicator on the 'Analytics cookies' toggle. 
            The colour contrast when the toggle is off doesn't meet colour contrast requirements. 
            This fails WCAG 2.2 success criteria 2.4.7 (Focus Visible) and 1.4.3 Contrast (Minimum).</p>
          <p>When zoomed in at 200% or 400% the focus indicator isn't visible on some menus. 
            This fails WCAG 2.2 success criterion 2.4.7 (Focus Visible).</p>
          <p>On some pages the focus indicator relies on colour change on interactive blue buttons such as Share this page. 
            This fails WCAG 2.2 success criterion 1.4.1 (Use of Colour).</p>
          <p>The tab ordering of the skip links is incorrect. This fails WCAG 2.2 success criterion 2.4.3 (Focus Order).</p>
          <p>Some of our pages skip a heading level. This makes navigation hard for keyboard and screen reader users. 
            This fails WCAG 2.2 success criteria 1.3.1 (Info and Relationships), 2.4.1 (Bypass Blocks) and 2.4.6 (Headings and Labels).</p>
          <p>Some items are not marked up correctly such as lists. This fails WCAG 2.2 success criterion 1.3.1 (Info and Relationships)</p>
          <p>The search input file does not contain a label and there is no remaining visible label to guide users. 
            This fails WCAG 2.2 success criteria 1.3.1 (Info and Relationships), 2.4.6 (Headings and Labels), 3.3.2 (Labels or Instructions) and 4.1.2 (Name, Role, Value).</p>
          <p>On some pages the drop down navigation shows in the incorrect place. This fails WCAG 2.2 success criterion 1.3.1 (Info and Relationships).</p>
          <p>Hover over text either repeats or is irrelevant to link. This fails WCAG 2.2 criterion 3.3.2 (Labels or Instruction).</p>
          <p>Some pages use directional language to identify the visual location of an element. Users with visual disabilities may find it difficult to locate the content. 
            Also, location of content can change depending on window or screen size. This fails WCAG 2.2 success criterion 1.3.3 (Sensory Characteristics).</p>
          <p>The title text is duplicated in some of our content links. This includes:</p>
            <ul style = {{'fontSize' : '17px'}}>
              <li>the service name links on the NHSBSA homepage</li>
              <li>the skip to content links on all pages</li>
              <li>the Freedom of Information link in the footer on all pages</li>
              <li>some link buttons</li>
            </ul>
          <p>This may cause difficulties for users of assistive technology. 
            This fails WCAG 2.2 success criteria 1.1.1 (Non text content) and 2.4.4 (Link Purpose In Context).</p>
          <p>Some link text does not describe where a link will take the user, or what the downloadable linked content is. 
            This fails WCAG 2.2 success criterion 2.4.4 (Link Purpose In Context).</p>
          <p>Some pages have an 'Ask us' icon or 'a opens in new tab' icon that has no text alternative. 
            This fails WCAG 2.2 success criterion 1.1.1 (Non-text content).</p>
          <p>It's not possible to navigate all pages on this website using speech recognition software. 
            This fails WCAG 2.2 success criteria 4.1.2 (Name, Role, Value), 2.5.3 (Label in Name) and 4.1.3 (Status Messages).</p>
          <p>On all accessibility statement pages hidden links show in the links menu for NVDA. This fails WCAG 2.2 success criterion 4.1.2 (Name, Role, Value).</p>

        <h3>Search</h3>
          <p>The code on the search results page does not let assistive technologies know:</p>
          <ul>
            <li>what all user interface components are for because more than one element has the same ID attribute</li>
            <li>when content on the page has changed if a search filter is selected</li>
          </ul>
          <p>This fails WCAG 2.2 success criterion and 4.1.2 (Name, Role, Value).</p>
        
        <h3>Tables</h3>
          <p>Data tables on our pages are not marked up correctly. Empty data cells, such as the top-left cell in a data table, are incorrectly marked as header cells. Assistive technology users may find this confusing. 
            This fails WCAG 2.2 success criterion (1.3.1 Info and Relationships).</p>
          <p>Non-data tables are used on some pages to position content for sighted users. Screen readers may interpret them as data tables. For example, screen readers will announce column and row numbers. Screen reader users may not understand the text within the table. 
            This fails WCAG 2.1 success criteria 1.3.1 (Info and Relationships) and 1.3.2 (Meaningful Sequence).</p>
        
        <h3>Videos</h3>
          <p>Some of our pages include videos which are embedded from a third-party site, such as YouTube. The video is displayed in a frame on our page which does not have a title. Screen readers cannot describe the contents of the video frame. 
            This fails WCAG 2.2 success criterion 3.3.2 (Labels or Instructions).</p>
          <p>The focus indicator isn't always visible when tabbing through links in video. 
            This fails WCAG 2.2 success criterion 2.4.7 (Focus Visible).</p>
          <p>The captions for our videos are automatic and may not always be accurate. This fails WCAG 2.2 success criterion 1.1.1 Captions (Prerecorded).</p>
          <p>Where a video is embedded on one of our pages, a link to download the video transcript is available.</p>
          <p>We plan to work with our website supplier and content editors to make the NHSBSA website more accessible.</p>
        
        <h4>PDFs and other documents</h4>
          <p>Many of our documents require a separate program to open them and are not accessible. For example, some of them:</p>
          <ul style = {{'fontSize' : '17px'}}>
            <li>are not tagged in a way that allows screen reader users to understand or navigate them</li>
            <li>do not have alternative text alongside informative images</li>
            <li>do not have correct heading structures</li>
            <li>do not have correct list structures</li>
            <li>do not have a high level of contrast between the text and background</li>
            <li>do not have a logical reading order</li>
            <li>contain complex table structures with merged cells and tables with no headings which keyboard users and screen reader users will find difficult to understand</li>
            <li>contain slides with missing or duplicate titles</li>
            <li>contain non-meaningful links</li>
            <li>are not written in plain English</li>
            <li>use directional language and colour to identify visual location of content</li>
            <li>include objects such as images and logos which are not in line with text</li>
          </ul>
          <p>Some links to documents are not descriptive enough or do not let users know what the downloadable linked content is. 
            For example, they do not inform the user that the link will download a PDF document. 
            This fails WCAG 2.2 success criterion 2.4.4 (Link Purpose In Context).</p>
          <p>We plan to make all our documents accessible or replace them with accessible HTML pages.</p>

        <h3>Content that's not within the scope of the accessibility regulations</h3>
        <h4>JavaScript</h4>
          <p>On the search results page, the search filters aren't accessible when JavaScript is disabled.</p>
        
        <h4>PDFs and other documents</h4>
          <p>Some of our PDFs and Word documents are essential to providing our services. For example, we have PDFs with information on how users can access our services, and forms published as Word documents. 
            We plan to either fix these or replace them with accessible HTML pages. </p>
          <p>The accessibility regulations <a href="https://www.legislation.gov.uk/uksi/2018/952/regulation/4/made">do not require us to fix PDFs or other documents published before 23 September 2018</a> if they're not essential to providing our services. 
            For example, we do not plan to fix historic strategies, business plans and annual reports. </p>
        
        <h2>What we're doing to improve accessibility</h2>
          <p>We're committed to making sure this website is compliant to WCAG 2.2 'AA' standard. 
            We're currently sourcing a supplier to work with us to improve the accessibility of our website by our next statement review.</p>
          <p>Our accessibility compliance statement will be reviewed regularly. Every newly released website will be designed, built and tested to meet 'AA' standards by default. </p>
        
        <h2>Preparation of this accessibility statement</h2>
          <p>This statement was prepared on 16 September 2020. It was last reviewed on 9 December 2024.</p> 
          <p>This website was last tested on 17 October 2024 against the WCAG 2.2 AA standard. The test was carried out by the Digital and Online Team.</p>
          <p>We tested a sample of the website screens to meet 'AA' WCAG 2.2 standards, using manual and automated tests.</p>
          <p>We run each webpage through automated Wave, Lighthouse and Axe accessibility tools then manually test with screen readers (NVDA) and standards checklists.</p>
          <p>These checklists contain standards that have been compiled using WCAG, the NHS service manual and Government Digital Service (GDS) guidance.</p>
        
        <h2>Other NHSBSA websites</h2>
          <p>Each NHSBSA website has its own accessibility page, with details of how accessible the website is, how to report problems and how to request information in an alternative format. 
            You can access these pages from the footer inside most websites. 
            You can also <a href="https://www.nhsbsa.nhs.uk/search?aggregated_field=%22accessibility%20statement%20for%22&service_taxonomy=&content_or_file_type=&sort_by=search_api_relevance&f%5B0%5D=content_or_file_type%3Acontent_page">view a list of accessibility statements for other NHSBSA websites.</a></p>
      </Fragment>
    ),     
  },
];